module.exports = __webpack_public_path__ + "static/media/cartoon-face.5921cbe4.png";